import React, { Component } from 'react';
// import PropTypes from 'prop-types';
// import createClass from 'create-react-class';
import { find, forEach, some } from 'lodash';

import TranslateManager from 'ts-translate-js';
const tr = TranslateManager.boundTR;


interface ComboProps {
    name?: string; // Controle name for forms
    items: any; // REST Resource to load
    valueField?: string;
    textField?: string;
    selectedValue?: any;
    onChange?: any;
    readOnly?: boolean;
    disabled?: boolean;
    supportsNone?: boolean;
    noneItemID?: any; // If the none item is supported, this is it's id
    supportsAll?: boolean;
    allItemID?: any; // If the All item is supported, this is it's id
    emptyComboMessage?: string;
    className?: string;
}

// Params: items: items, getId: f(item -> itemid), getInnerCtl: f(item -> itemControl). Opt: onItemSelected: f(itemId)
export class Combo extends Component<ComboProps> {
    static readonly defaultProps: Partial<ComboProps> = {
        items: [],
        valueField: "id",
        textField: "name",
        supportsNone: false,
        supportsAll: false,
        readOnly: false,
        disabled: false
    };

    constructor(props: ComboProps) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.emulateChange = this.emulateChange.bind(this);
    }

    emulateChange(value) {
        this.handleChange({
            target: {
                name: this.props.name,
                value: value
            }
        });
    }

    handleChange(e) {
        if(this.props.onChange != null)
            this.props.onChange(e);
    }

    render() {
        let ctl = null;

        if(this.props.readOnly) {

            if(this.props.supportsNone && this.props.selectedValue === this.props.noneItemID)
                ctl = <span>{tr("Aucun")}</span>;
            else if(this.props.supportsAll && this.props.selectedValue === this.props.allItemID)
                ctl = <span>{tr("Tous")}</span>;
            else { // Look in the items
                const foundItem = find(this.props.items, (item) => item[this.props.valueField] === this.props.selectedValue);
                if(foundItem != null)
                    ctl = <span>{foundItem[this.props.textField]}</span>;
                else
                    ctl = <span>{tr("Donnée inaccessible")}</span>;
            }
        }
        else {

            let options = [];

            if(this.props.supportsNone)
                options.push(<option value={this.props.noneItemID} key={this.props.noneItemID}>{tr("AUCUN")}</option>);

            if(this.props.supportsAll)
                options.push(<option value={this.props.allItemID} key={this.props.allItemID}>{tr("TOUS")}</option>); // TODO: Peut etre feminin

            forEach(this.props.items, (item) => {
                const id = item[this.props.valueField];
                const text = item[this.props.textField];
                options.push(<option value={id} key={id}>{text}</option>);
            });

            if (options.length === 0 && this.props.emptyComboMessage)
                options.push(<option key="noitem">{this.props.emptyComboMessage}</option>);

            ctl = (
                <select className={this.props.className} name={this.props.name} disabled={this.props.disabled} onChange={this.handleChange} value={this.props.selectedValue}>
                    {options}
                </select>
            );
        }
        return ctl;
    }

    componentDidMount() {
        // Check if we can assing the selected ID, if not, raise a selected item change
        const found = some(this.props.items, (item) => item[this.props.valueField] === this.props.selectedValue);

        let selectedIDToUse;
        if(found)
            selectedIDToUse = this.props.selectedValue;
        else if(this.props.supportsNone)
            selectedIDToUse = this.props.noneItemID;
        else if(this.props.supportsAll)
            selectedIDToUse = this.props.allItemID;
        else
            selectedIDToUse = (this.props.items.length > 0 ? this.props.items[0][this.props.valueField] : null);
        this.emulateChange(selectedIDToUse);
    }

}

// interface ComboNumberProps {
//     min: number;
//     max: number;
//     value?: number;
//     onChange?: any;
//     selectedValue?: number;
//     name?: string;
// }

// export const ComboNumber = createClass<ComboNumberProps>({
//     displayName: "ComboNumber",

//     propTypes: {
//         min: PropTypes.number.isRequired,
//         max: PropTypes.number.isRequired,
//         value: PropTypes.number,
//         onChange: PropTypes.func
//     },

//     emulateChange: function(value){
//         this.handleChange({
//             target: {
//                 name: value,
//                 value: value
//             }
//         });
//     },

//     handleChange: function(e) {
//         if(this.props.onChange != null)
//             this.props.onChange(e);
//     },

//     render: function () {
//         let optionList = [];
        
//         for(let i = this.props.min; i <= this.props.max; i++) {

//             optionList.push(<option value={i} key={i}>{i}</option>);
//         }

//         return (
//             <select name={this.props.name} {...this.props} onChange={this.handleChange} defaultValue={this.props.selectedValue} value={this.props.value}>
//                 {optionList}
//             </select>
//         );
//     },

//     componentDidMount: function(){

//         // Check if we can assing the selected ID, if not, raise a selected item change
//         const found = (this.props.value == -1 && this.props.selectedValue != null);

//         if(found)
//             this.emulateChange(this.props.selectedValue);
//     }
// });
